/**
 * This is a React component that renders a list of customizable product variations to be removed from
 * the cart.
 * @returns A React component that conditionally renders a div with a list of
 * RemoveVariationsProductComponent components based on the value of the relatedDiv prop.
 */
import React from "react";
import { RELATEABLE_DIV_SHOW_ON_QUICKVIEW } from "../../../utils/Constants";
import RemoveVariationsProductComponent from "../RemoveVariationsProductComponent";

const DeleteVariation = ({
  id,
  relatedDiv,
  filteredCartForVariant,
  triggerQuickViewModal,
  setRelatedDiv,
}) => {
  return (
    <>
      {relatedDiv ==
        RELATEABLE_DIV_SHOW_ON_QUICKVIEW.REMOVEPRODUCT_VARIANTS && (
        <div className="deleteVariationFromCart">
          <ul className="removeVariation_ul px-2">
          <div className="removeVariation-info">
            <h1 style={{ fontWeight: 600 }}>Remove item</h1>
            <small>
              You have multiple customizations for Current Product.
              <br />
              Choose which one to remove.
            </small>
          </div>
            {filteredCartForVariant.map((cartItemObj, index) => (
              <RemoveVariationsProductComponent
                key={index}
                cartItemObj={cartItemObj}
                triggerQuickViewModal={triggerQuickViewModal}
                setRelatedDiv={setRelatedDiv}
                id={id}
              />
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default DeleteVariation;
